<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="500px">
            <template v-slot:activator="{ on }">
                <v-btn class="caption" block color="primary" text dark v-on="on">Создать группу</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Группа карточек</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{cardListModel.id === null ? ' Создать' : '\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container>
                        <v-form
                            ref="form"
                            v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="cardListModel.title"
                                            :counter="35"
                                            label="Название группы"
                                            class="ma-2 pa-2"
                                            required
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" xs12 class="py-1 px-4">
                                    <v-switch
                                            class="ma-0 pa-0"
                                            v-model="cardListModel.status"
                                            inset
                                            label="Видимость группы"
                                            color="primary"
                                            :false-value="2"
                                            :true-value="1"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="6" class="py-0 pl-0">
                                    <v-select
                                            v-model="cardListModel.type"
                                            label="Тип группы"
                                            class="ma-0 ml-3 pa-0 pr-0 pt-3"
                                            :items="[{value: 1, text: 'Обычный'}, {value: 2, text: 'Открытые заявки'}]"
                                            dense
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
    
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'MessageForm',
    components: {
    },
    data() {
        return {
            show: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Операция прошла успешно!'
            },
            snackbar: false,
            cardListModel: {
                id: null,
                title: ''
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.'
            },
            valid: false
        }
    },
    props: ['cardListId', 'dialog'],
    methods: {
        saveValue: function () {
            this.$store.dispatch('cards/cardListCreate', this.cardListModel).then(response => {
                this.paramsSnackbar.color = 'error'
                if (response.ok) {
                    if (this.cardListModel.id == null) {
                        this.$emit('addNewCardsList', response.response.data)
                    }
                    this.cardListModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                }
                this.paramsSnackbar.text = response.response.text
                this.snackbar = true
            })
        },
        loadModel(id) {
            if (id === null) {
                this.cardListModel = Object.assign({}, this.cardListModelDef)
            } else {
                this.cardListModel = Object.assign({}, this.getCardListById(id))
            }
            if (this.cardListModel.card_category_id == null) {
                this.cardListModel.card_category_id = this.$route.params[1]
            }
        }
    },
    computed: {
        ...mapGetters({
            cardLists: 'cards/cardLists',
            getCardListById: 'cards/getCardListById',
            cardListModelDef: 'cards/cardListModelDef'
        })
    },
    watch: {
        dialog() {
            this.dialog === true ? this.show = true : this.show = false
        },
        show() {
            if (this.show === false) {
                this.cardListModel = Object.assign({}, this.cardListModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            } else {
                this.loadModel(this.cardListId)
            }
        }
    },
    created() {
        this.$store.dispatch('cards/changeBotIdModelDefault', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
